interface IEvent {
  category: string;
  action: string;
}

export const AddsFarmEvent: Record<string, IEvent> = {
  sale: {
    category: 'farm-adds-sale',
    action: ' کاربر وارد بخش آگهی های حراجی مزرعه شد',
  },
  auction: {
    category: 'farm-adds-auction',
    action: 'کاربر وارد بخش آگهی های مزایده مزرعه شد',
  },
  prepayment: {
    category: 'farm-adds-prepayment',
    action: 'کاربر وارد بخش آگهی های سلف مزرعه شد',
  },
  all: {
    category: 'farm-adds-all',
    action: 'کاربر وارد بخش مشاهده همه مزرعه شد',
  },
};
export const FarmEvents: Record<string, IEvent> = {
  login: {
    category: 'from-farm-to-hojre',
    action: 'کاربر از مزرعه وارد حجره شد',
  },
  logout: {
    category: 'from-hojre-to-farm',
    action: 'کاربر از حجره وارد مزرعه شد',
  },
  home: {
    category: 'footer-item-farm-home-checked',
    action: 'کاربر وارد صفحه اصلی مزرعه شد',
  },
  buyers: {
    category: 'footer-item-farm-shoppers-checked',
    action: 'کاربر وارد بخش خریداران مزرعه شد',
  },
  'add-ad': {
    category: 'footer-item-farm-add-ad-checked',
    action: 'کاربر وارد بخش ثبت آگهی مزرعه شد',
  },
  chats: {
    category: 'footer-item-farm-messages-checked',
    action: 'کاربر وارد بخش پیام ها مزرعه شد',
  },
  account: {
    category: 'footer-item-farm-myAccount-checked',
    action: 'کاربر وارد بخش اکانت مزرعه شد',
  },
  sale: {
    category: 'arm-add-sale',
    action: 'کاربر وارد ثبت آگهی حراجی مزرعه شد',
  },
  auction: {
    category: 'arm-add-auction',
    action: 'کاربر وارد ثبت آگهی مزایده مزرعه شد',
  },
  simple: {
    category: 'farm-add-simple',
    action: 'کاربر وارد ثبت آگهی ساده مزرعه شد',
  },
  addedSimple: {
    category: 'wholesaler-add-simple',
    action: '  کاربر آگهی ساده در مزرعه اضافه کرد',
  },
  addedPrepayment: {
    category: 'wholesaler-add-prepayment',
    action: '  کاربر آگهی سلف در مزرعه اضافه کرد',
  },
  addedPost: {
    category: 'wholesaler-add-post',
    action: 'کاربر وارد ثبت آگهی فروش فروشگاه مزرعه شد',
  },
  addedAuction: {
    category: 'wholesaler-add-post',
    action: 'کاربر آگهی مزایده در مزرعه ثبت کرد',
  },
  addedSale: {
    category: 'wholesaler-add-post',
    action: 'کاربر آگهی حراجی در مزرعه ثبت کرد',
  },
  post: {
    category: 'farm-add-post',
    action: 'کاربر وارد ثبت آگهی فروش مزرعه شد',
  },
  wanted: {
    category: 'farm-add-wanted',
    action: 'کاربر وارد ثبت آگهی خرید مزرعه شد',
  },
  addingWanted: {
    category: 'farm-add-wanted-added',
    action: 'کاربر   آگهی خرید در مزرعه ثبت کرد',
  },
  prepayment: {
    category: 'wholesaler-adds-prepayment',
    action: 'کاربر وارد بخش آگهی های سلف مزرعه شد',
  },
};
export const AddsWholesalerEvent: Record<string, IEvent> = {
  sale: {
    category: 'wholesaler-adds-sale',
    action: 'کاربر وارد بخش آگهی های حراجی فروشگاه شد',
  },
  auction: {
    category: 'wholesaler-adds-auction',
    action: 'کاربر وارد بخش آگهی های مزایده فروشگاه شد',
  },
  prepayment: {
    category: 'wholesaler-adds-prepayment',
    action: 'کاربر وارد بخش آگهی های سلف فروشگاه شد',
  },
  all: {
    category: 'wholesaler-adds-all',
    action: 'کاربر وارد بخش مشاهده همه فروشگاه شد',
  },
};
export const WholesalerEvent: Record<string, IEvent> = {
  home: {
    category: 'footer-item-wholesaler-home-checked',
    action: 'کاربر وارد صفحه اصلی فروشگاه شد',
  },
  buyers: {
    category: 'footer-item-wholesaler-shoppers-checked',
    action: 'کاربر وارد بخش خریداران فروشگاه شد',
  },
  chats: {
    category: 'footer-item-wholesaler-messages-checked',
    action: 'کاربر وارد بخش پیام ها فروشگاه شد',
  },
  'add-ad': {
    category: 'footer-item-wholesaler-add-ad-checked',
    action: 'کاربر وارد بخش ثبت آگهی فروشگاه شد',
  },
  account: {
    category: 'footer-item-wholesaler-myAccount-checked',
    action: 'کاربر وارد بخش اکانت فروشگاه شد',
  },
  sale: {
    category: 'wholesaler-add-sale',
    action: 'کاربر وارد ثبت آگهی حراجی فروشگاه شد',
  },
  auction: {
    category: 'wholesaler-add-auction',
    action: 'کاربر وارد ثبت آگهی مزایده فروشگاه شد',
  },
  simple: {
    category: 'wholesaler-add-simple',
    action: 'کاربر وارد ثبت آگهی ساده فروشگاه شد',
  },
  prepayment: {
    category: 'wholesaler-add-prepayment',
    action: 'کاربر وارد ثبت آگهی سلف فروشگاه شد',
  },
  post: {
    category: 'wholesaler-add-post',
    action: 'کاربر وارد ثبت آگهی فروش فروشگاه شد',
  },
  addedSimple: {
    category: 'wholesaler-add-simple',
    action: '  کاربر آگهی ساده در فروشگاه اضافه کرد',
  },

  addedAuction: {
    category: 'wholesaler-add-post',
    action: 'کاربر آگهی مزایده در فروشگاه ثبت کرد',
  },
  addedSale: {
    category: 'wholesaler-add-post',
    action: 'کاربر آگهی حراجی در فروشگاه ثبت کرد',
  },
  addedPost: {
    category: 'wholesaler-add-post',
    action: 'کاربر وارد ثبت آگهی فروش فروشگاه شد',
  },

  wanted: {
    category: 'wholesaler-add-wanted',
    action: 'کاربر وارد ثبت آگهی خرید فروشگاه شد',
  },
  addingWanted: {
    category: 'wholesaler-add-wanted-added',
    action: 'کاربر   آگهی خرید در فروشگاه ثبت کرد',
  },
};
